import * as React from 'react';
import * as NEA from 'fp-ts/NonEmptyArray';
import * as A from 'fp-ts/Array';
import * as R from 'fp-ts/Record';
import { pipe } from 'fp-ts/lib/function';
import { AssistEventFragment } from '../Stats/utils';
import { Card } from '../../../components/Card';
import { TextLink } from '../../../components/ClickableText';
import { PlayerNameWithAvatar } from '../components/PlayerNameWithAvatar';
import { CardHeading } from '../../../components/CardHeading';
import { isNil } from '../../../utils/isNil';

interface Props {
  assists: NEA.NonEmptyArray<AssistEventFragment>;
  editLink?: string;
  isSignedIn: boolean;
}

export const AssistCard: React.FC<Props> = ({
  assists,
  editLink,
  isSignedIn,
}) => {
  const groupedAssisters = pipe(
    assists,
    NEA.groupBy((a) => a.player.id),
    R.toArray,
    A.map(
      ([, assists]) =>
        [pipe(NEA.head(assists), (a) => a.player), assists.length] as const,
    ),
  );

  return (
    <Card className="space-y-4 bg-white ">
      <CardHeading>Assists</CardHeading>
      <ul className="space-y-3">
        {groupedAssisters.map(([player, assistCount]) => {
          return (
            <li key={player.id} className="flex items-center">
              <PlayerNameWithAvatar player={player} linkToPlayer={isSignedIn} />
              {assistCount > 1 ? (
                <span className="text-amber-600 ml-2">{assistCount}</span>
              ) : null}
            </li>
          );
        })}
      </ul>
      {!isNil(editLink) ? (
        <p className="text-sm text-right">
          <TextLink to={editLink}>Edit</TextLink>
        </p>
      ) : null}
    </Card>
  );
};
